import { UseQueryOptions } from '@tanstack/react-query';
import { SMSSenderProfile } from 'domains/content/types';
import { CuredApiPaths } from 'models/enums';
import useQuery from '../useQuery';
import QueryKeys from './keys';

const useSmsSenderProfileById = (
    smsSenderProfileId: number | null,
    reactQueryOptions?: UseQueryOptions<SMSSenderProfile, Error>
) =>
    useQuery<SMSSenderProfile>(
        QueryKeys.SMS_SENDER_PROFILE_ID(smsSenderProfileId),
        `${CuredApiPaths.SENDER_PROFILES}/sms/${smsSenderProfileId}`,
        {
            ...reactQueryOptions,
            enabled: reactQueryOptions?.enabled !== false && !!smsSenderProfileId,
        }
    );

export default useSmsSenderProfileById;
